<div fxLayout="column" fxLayoutAlign="center center" class="main-container">
    <h1>{{isEdit ? 'Edit' : 'Add'}} enrichment rule {{isEdit ? 'in' : 'to'}} "{{ruleset ? ruleset.DisplayName : ''}}"
        ruleset</h1>
    <div>
        <div [formGroup]="addEditRuleFrom">
            <div>
                <h2>Criteria</h2>
            </div>
            <div>
                <mat-radio-group aria-label="Select a rule type" formControlName="ruleType">
                    <mat-radio-button value="exactMatch">Exact Match</mat-radio-button>
                    <mat-radio-button value="beginsWith">Begins With</mat-radio-button>
                    <mat-radio-button value="contains">Contains</mat-radio-button>
                    <mat-radio-button value="regEx">Regular Expression</mat-radio-button>
                </mat-radio-group>
            </div>
            <div *ngIf="addEditRuleFrom.value.ruleType === 'exactMatch'">
                <mat-form-field style="width: 20rem;">
                    <mat-label>Description to match</mat-label>
                    <input matInput formControlName="ruleExpression">
                </mat-form-field>
            </div>
            <div *ngIf="addEditRuleFrom.value.ruleType === 'beginsWith'">
                <mat-form-field style="width: 20rem;">
                    <mat-label>Description begins with</mat-label>
                    <input matInput formControlName="ruleExpression">
                </mat-form-field>
            </div>
            <div *ngIf="addEditRuleFrom.value.ruleType === 'contains'">
                <mat-form-field style="width: 20rem;">
                    <mat-label>Description contains</mat-label>
                    <input matInput formControlName="ruleExpression">
                </mat-form-field>
            </div>
            <div *ngIf="addEditRuleFrom.value.ruleType === 'regEx'">
                <mat-form-field style="width: 20rem;">
                    <mat-label>Description matches regular expression</mat-label>
                    <input matInput formControlName="ruleExpression">
                </mat-form-field>
            </div>
            <div>
                <h2>Actions</h2>
                <div>
                    <div>
                        <div>
                            <mat-checkbox formControlName="applyCategory">Apply Category</mat-checkbox>&nbsp;
                        </div>
                        <div>
                            <mat-form-field style="width: 20rem;">
                                <mat-label>Category Group</mat-label>
                                <mat-select formControlName="categoryGroup"
                                    (selectionChange)="buildCategories(addEditRuleFrom.value.categoryGroup)">
                                    <mat-option *ngFor="let group of categoryGroupData" [value]="group._id">
                                        {{group.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>&nbsp;
                            <mat-form-field style="width: 20rem;">
                                <mat-label>Category</mat-label>
                                <mat-select formControlName="category">
                                    <mat-option *ngFor="let cat of categoryLists" [value]="cat._id">
                                        {{cat.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div>
                            <mat-checkbox formControlName="applyTag">Apply Tag</mat-checkbox>&nbsp;
                        </div>
                        <div>
                            <mat-form-field style="width: 20rem;">
                                <mat-label>Tag</mat-label>
                                <input matInput formControlName="tag">
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div>
                            <mat-checkbox formControlName="markAsIncome">Set as Income</mat-checkbox>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>Income Type</mat-label>
                                <mat-select formControlName="incomeType">
                                    <mat-option *ngFor="let incType of incTypes | keyvalue" [value]="incType.key">{{incType.value}}</mat-option>
                                </mat-select>
                            </mat-form-field>&nbsp;
                            <mat-form-field style="width: 20rem;">
                                <mat-label>Income source name</mat-label>
                                <input matInput formControlName="incomeSourceName">
                            </mat-form-field>
                        </div>
                        <div>

                        </div>
                    </div>
                    <div>
                        <div>
                            <mat-checkbox formControlName="setTransactionType">Set Transaction Type</mat-checkbox>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>Transaction Type</mat-label>
                                <mat-select formControlName="transactionType">
                                    <mat-option *ngFor="let txnType of transTypes | keyvalue" [value]="txnType.key">{{txnType.value}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center">
                <button *ngIf="isEdit === false" mat-raised-button color="primary" (click)="onClickAdd()"
                    [disabled]="!addEditRuleFrom.valid || runningTest">Add</button>&nbsp;
                <button *ngIf="isEdit === true" mat-raised-button color="primary" (click)="onClickUpdate()"
                    [disabled]="!addEditRuleFrom.valid || runningTest">Update</button>&nbsp;
                <button mat-raised-button color="accent" (click)="onClickRunTest()"
                    [disabled]="!addEditRuleFrom.valid || runningTest" [class.spinner]="runningTest">Test</button>&nbsp;
                <button mat-raised-button color="accent" (click)="onClickCancel()">Cancel</button>
            </div>
            <div>
                <h2>Test Results</h2>
                <table mat-table [dataSource]="testResults">
                    <ng-container matColumnDef="accountName">
                        <th mat-header-cell *matHeaderCellDef>Account</th>
                        <td mat-cell *matCellDef="let result">{{result.AccountName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let result">{{result.Before.TransactionDate | amDateFormat:'DD MMM'}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef>Description</th>
                        <td mat-cell *matCellDef="let result">{{result.Before.Description}}</td>
                    </ng-container>
                    <ng-container matColumnDef="amount">
                        <th mat-header-cell *matHeaderCellDef>Amount</th>
                        <td mat-cell *matCellDef="let result">{{result.Before.Amount | currency}}</td>
                    </ng-container>
                    <ng-container matColumnDef="result">
                        <th mat-header-cell *matHeaderCellDef>Result</th>
                        <td mat-cell *matCellDef="let result">
                            <div *ngFor="let act of result.AppliedRules[0].Actions">
                                <div *ngIf="act.ActionType === 'applyCategory'">
                                    <div>Transaction Group: update from "{{result.Before.TransactionCategoryGroup ?
                                        result.Before.TransactionCategoryGroup : 'null'}}" to
                                        "{{result.After.TransactionCategoryGroup ? result.After.TransactionCategoryGroup
                                        : 'null'}}"</div>
                                    <div>Transaction Category: updated from "{{result.Before.TransactionCategory ?
                                        result.Before.TransactionCategory : 'null'}}" to
                                        "{{result.After.TransactionCategory ? result.After.TransactionCategory :
                                        'null'}}"</div>
                                </div>
                                <div *ngIf="act.ActionType === 'applyTag'">Transaction tagged as
                                    "{{act.ActionExpression}}"</div>
                                <div *ngIf="act.ActionType === 'isIncome'">Transaction set as income: "{{incTypes[result.After.IncomeType]}}" from "{{result.After.IncomeSource}}"</div>
                                <div *ngIf="act.ActionType === 'setTransactionType'">
                                    Transaction Type: updated from "{{transTypes[result.Before.TransactionType]}}" to
                                    "{{transTypes[result.After.TransactionType]}}"
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="testResultsColumnsDisplay"></tr>
                    <tr mat-row *matRowDef="let row; columns: testResultsColumnsDisplay;"></tr>
                </table>
                <div *ngIf="testResults.length === 0">No Test Results Available</div>
            </div>
        </div>

    </div>
</div>